module.exports = __webpack_public_path__ + "static/img/pedals-compressor.4879f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-compressor.png
// module id = vJYn
// module chunks = 12